import Vue from "vue";
import VeeValidate, { Validator } from "vee-validate";
import VueClipboard from "vue-clipboard2";
import VueRouter from "vue-router";
import App from "@/app/App";
import routes from "@/app/routes";
import store from "@/app/store";
import DSTheme from "ds-theme/src/main.js";
import "./app/scss/main.scss";
import { closeMobileMenu } from "@/app/ui/store/mutations";
import { messages } from "@/app/validators";
import VueAnalytics from "vue-analytics";

Vue.use(DSTheme);
Vue.use(VueRouter);
Vue.use(VeeValidate);
Vue.use(VueClipboard);
Vue.config.productionTip = false;

const router = new VueRouter({
  mode: "history",
  routes
});

Vue.use(VueAnalytics, {
  id: "UA-41462943-14",
  router
});

router.afterEach(() => {
  store.commit(closeMobileMenu());
  window.scrollTo(0, 0);
});

Object.entries(messages).forEach(([key, value]) => {
  Validator.localize(key, value);
});

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js